module.exports = __webpack_public_path__ + "img/message.454787d6.svg";